import { render, staticRenderFns } from "./GitHubTrending.vue?vue&type=template&id=4f8b5d3e&scoped=true&"
import script from "./GitHubTrending.vue?vue&type=script&lang=js&"
export * from "./GitHubTrending.vue?vue&type=script&lang=js&"
import style0 from "./GitHubTrending.vue?vue&type=style&index=0&id=4f8b5d3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b5d3e",
  null
  
)

export default component.exports